import { render, staticRenderFns } from "./CoachManagerLongevity.vue?vue&type=template&id=69219ed0"
import script from "./CoachManagerLongevity.vue?vue&type=script&lang=js"
export * from "./CoachManagerLongevity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports